import { FC, ReactNode } from 'react'

interface LayoutProps {
  children: ReactNode
  className?: string
}

const Layout: FC<LayoutProps> = ({ children, className = '' }) => {
  return (
    <div className={`min-h-screen bg-gray-50 dark:bg-gray-900 ${className}`}>
      <main className="container mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  )
}

export default Layout
